// extracted by mini-css-extract-plugin
export var bodyRow = "_eg-d";
export var cardColumns = "_eg-e";
export var ellipsesOverflow = "_eg-2";
export var flatBottomCorners = "_eg-3";
export var flatTopCorners = "_eg-4";
export var headerActionsDropdown = "_eg-f";
export var headerBottomRow = "_eg-c";
export var headerTopRow = "_eg-b";
export var orderDetailsWrapper = "_eg-0";
export var orderInfoContainer = "_eg-1";
export var productDetails = "_eg-9";
export var productImage = "_eg-5";
export var responsiveTable = "_eg-8";
export var shipmentContainer = "_eg-a";
export var tableBottomLeft = "_eg-6";
export var tableBottomRight = "_eg-7";
export var trackingLink = "_eg-g";